<template>
  <div>
    <h3 style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
      关于我们
    </h3>

  <el-tabs v-model="activeName" @tab-click="handleClick" width="50%">
    <el-tab-pane label="基本设置" name="first">
      <el-form ref="form" :model="form" label-width="120px" >
        <el-form-item label="系统名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="门户地址">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="网站标题">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="SEO描述">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="SEO关键字">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="联系地址">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="传真">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="备案号">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="站长统计代码">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="是否开放网站">
          <el-radio-group v-model="form.resource">
            <el-radio label="站点开放"></el-radio>
            <el-radio label="站点关闭"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关闭信息">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存信息</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <el-tab-pane label="图片设置" name="second"><el-form ref="form" :model="form" label-width="120px" >
      <el-form-item label="图片根路径">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="favicon">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="logo">
        <el-input v-model="form.name"></el-input>
      </el-form-item>

    </el-form>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
    export default {
        name: "Settings",
      data() {
        return {
          activeName: 'first',
          form: {}
        }
      },
      methods: {
        handleClick(tab, event) {
          console.log(tab, event);
        },
        onSubmit() {
          console.log('submit!');
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/Settings.vue